import Services from '../Service'

class ClienteService extends Services {
  constructor() {
    super()
    this.resource = 'clientes'
  }

  async getClientes(params) {
    return await this.getAPI(this.resource, params)
  }
}

export default new ClienteService()
